module.exports = __webpack_public_path__ + "media/images/statistics-c5ccd626af89c9b093787d9bbddea559.jpg";